import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const EscalationReports = () => {
  const [escalations, setEscalations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterGym, setFilterGym] = useState('');
  const [filterCity, setFilterCity] = useState('');
  const [filterDelay, setFilterDelay] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    const fetchEscalations = async () => {
      setLoading(true);
      const token = localStorage.getItem('token');
      const res = await fetch('/api/coo/escalations', {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      setEscalations(data.escalations || []);
      setLoading(false);
    };
    fetchEscalations();
  }, []);

  const filtered = escalations.filter(e =>
    (!filterGym || e.gymName.toLowerCase().includes(filterGym.toLowerCase())) &&
    (!filterCity || e.city.toLowerCase().includes(filterCity.toLowerCase())) &&
    (!filterDelay || e.delayDays >= parseInt(filterDelay))
  );

  return (
    <div className="p-4">
      {/* Breadcrumbs and Back */}
      <div className="mb-4 flex items-center text-sm text-gray-500">
        <button onClick={() => navigate('/coo-dashboard')} className="mr-2 px-2 py-1 bg-gray-200 rounded hover:bg-gray-300">← Back</button>
        <Link to="/coo-dashboard" className="hover:underline text-wtf-red">Home</Link>
        <span className="mx-2">/</span>
        <span>Escalations</span>
      </div>
      <h2 className="text-xl font-bold mb-4">Escalations</h2>
      <div className="flex gap-4 mb-4">
        <input
          type="text"
          placeholder="Filter by Gym Name"
          value={filterGym}
          onChange={e => setFilterGym(e.target.value)}
          className="border px-2 py-1 rounded"
        />
        <input
          type="text"
          placeholder="Filter by City"
          value={filterCity}
          onChange={e => setFilterCity(e.target.value)}
          className="border px-2 py-1 rounded"
        />
        <input
          type="number"
          placeholder="Min Delay Days"
          value={filterDelay}
          onChange={e => setFilterDelay(e.target.value)}
          className="border px-2 py-1 rounded w-32"
        />
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border rounded">
          <thead>
            <tr>
              <th className="px-4 py-2 border">Gym Name</th>
              <th className="px-4 py-2 border">City</th>
              <th className="px-4 py-2 border">Stage</th>
              <th className="px-4 py-2 border">Assigned Manager</th>
              <th className="px-4 py-2 border">Delay Days</th>
              <th className="px-4 py-2 border">Reason</th>
              <th className="px-4 py-2 border">Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={7} className="text-center py-8">Loading...</td></tr>
            ) : filtered.length === 0 ? (
              <tr><td colSpan={7} className="text-center py-8">No escalations found.</td></tr>
            ) : (
              filtered.map((e, idx) => (
                <tr key={idx} className="border-b">
                  <td className="px-4 py-2 border">{e.gymName}</td>
                  <td className="px-4 py-2 border">{e.city}</td>
                  <td className="px-4 py-2 border">{e.stage}</td>
                  <td className="px-4 py-2 border">{e.assignedManager}</td>
                  <td className="px-4 py-2 border">{e.delayDays}</td>
                  <td className="px-4 py-2 border">{e.reason}</td>
                  <td className="px-4 py-2 border">
                    <button className="text-blue-600 hover:underline mr-2">View</button>
                    <button className="text-gray-600 hover:underline">Comment</button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EscalationReports; 